import React from 'react';
import * as Styled from './DownloadButton.styled';
import * as automationLabels from '@Utils/facade/edgeTs/automationLabels';

interface OwnProps {
  downloadLink: string;
  download: string;
}

const Download: React.FC<OwnProps> = ({ downloadLink, download }) => {
  return (
    <Styled.Download
      target="_blank"
      href={downloadLink}
      {...automationLabels.getProps('download.button')}
    >
      {download}
    </Styled.Download>
  );
};

export default Download;
